import styled from 'styled-components';
import React from 'react';
import { Container, ContentContainer } from '../../components/Wrapper/Wrapper';
import TileHeader from '../../components/TileHeader/TileHeader';
import { Toggle } from 'carbon-components-react';
import { getClientAdditionalInfo } from '../../api/clients';

const Analytics = () => {
  const [isGaToggle, setIsGaToggle] = React.useState(true);
  const [url, setUrl] = React.useState("");
  const [dataDogUrl, setDataDogUrl] = React.useState("");

  React.useEffect(() => {
    const clientName = localStorage.getItem('client');
    if (clientName) {
      getClientAdditionalInfo(clientName).then(additionalInfo => {
        setUrl(additionalInfo?.url || "");
        setDataDogUrl(additionalInfo?.dataDogUrl || "");
      }).catch(err => {
        console.error("Failed to fetch client analytics URLs:", err);
      });
    }
  }, []);

  return (
    <Container>
      <ContentContainer>

        <PageContent>

          <TileHeader 
            title="Analytics"
            size="lg"
          />
          <Toggle
							// id={``}
							labelA="Google Analytics"
							labelB="Advanced Analytics"
              onClick={() => {
                setIsGaToggle(!isGaToggle)
              }}
							// disabled={true}
						/>
           <iframe
                width="100%"
                height="950"
                src={isGaToggle ? url : dataDogUrl}
                frameBorder="0"
                sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-downloads"
                allowFullScreen></iframe>
        </PageContent>

      </ContentContainer>
    </Container>
  );
};

export default Analytics;


const PageContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding-top: 28px;
`